function formatPercent(value) {
  if (value === null || value === undefined) {
    return null;
  }

  return value.toLocaleString("sv-SE", { useGrouping: false }) + "%";
}

export function createFixedPriceProjectColumns(formatHours, formatMoney) {
  return [
    { header: "Kund", value: (project) => project.customername },
    { header: "Projekt", value: (project) => project.project_name },
    { header: "PO", value: (project) => project.extprojectid },
    { header: "Start", value: (project) => project.start_date },
    { header: "Stopp", value: (project) => project.stop_date },
    { header: "Budget timmar", value: (project) => formatHours(project.budget_hours) },
    { header: "Budget kr", value: (project) => formatMoney(project.budget_money) },
    { header: "Rapporterade timmar", value: (project) => formatHours(project.used_hours) },
    { header: "Rapporterade kr", value: (project) => formatMoney(project.used_money) },
    { header: "Fakturerade timmar", value: (project) => formatHours(project.invoiced_hours) },
    { header: "Fakturerade kr", value: (project) => formatMoney(project.invoiced_money) },
    { header: "Kvar timmar", value: (project) => formatHours(project.remaining_hours) },
    { header: "Kvar kr", value: (project) => formatMoney(project.remaining_money) },
    { header: "Förbrukning", value: (project) => formatPercent(project.used_percent) },
  ];
}

export function buildFixedPriceProjectExportData(projects, columns) {
  return projects.map((project) =>
    columns.map((column) => column.value(project))
  );
}
